import { render } from "./QButton.vue?vue&type=template&id=694b8258"
import script from "./QButton.vue?vue&type=script&lang=js"
export * from "./QButton.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__